<script lang="ts">
  import Button from "../Button.svelte";
  import Icon from "../Icon.svelte";

  export let url: string;

  const encodeUrl = () => {
    url = encodeURI(url);
  };
</script>

<Button title="Encodieren - Mit dieser Funktion können Sie URLs kodieren/normalisieren. Dies ist z.B. notwendig, wenn die URL Leerzeichen oder Sonderzeichen enthält." size="extra-small" on:click={encodeUrl}>
  <Icon variant="wandWithSparkle" />
</Button>